import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/lib/media";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight, CalendarDays, MapPin } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((res) => setPosts(res.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO
        title="Blog"
        description="Stories, updates and physiotherapy insights from PhysioAbhi Healthcare Foundation's activities and community events."
        path="/blog"
      />
      <PageHeader
        eyebrow="Blog"
        title="Stories, insights & updates."
        subtitle="Perspectives from our physiotherapists and stories from the communities we serve."
      />
      <section className="px-5 md:px-10 py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {loading && <p data-testid="blog-loading" className="text-muted-foreground">Loading posts…</p>}
          {!loading && posts.length === 0 && <p data-testid="blog-empty" className="text-muted-foreground">No posts yet. Check back soon.</p>}
          {posts.map((post, i) => (
            <Reveal key={post.id} delay={i * 0.08}>
              <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.id}`} className="group block border border-border hover:border-accent transition-colors">
                {post.featured_image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={resolveImageUrl(post.featured_image)} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                )}
                <div className="p-6">
                  {(post.event_date || post.event_location) && (
                    <div className="flex flex-wrap gap-3 text-xs text-accent mb-2">
                      {post.event_date && <span className="flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" />{post.event_date}</span>}
                      {post.event_location && <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{post.event_location}</span>}
                    </div>
                  )}
                  <h3 className="font-heading text-xl leading-snug">{post.title}</h3>
                  <p className="text-muted-foreground text-sm mt-2 leading-relaxed">{post.excerpt}</p>
                  <span className="inline-flex items-center gap-1 text-sm mt-4 text-foreground/70 group-hover:text-accent transition-colors">
                    Read story <ArrowUpRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
